import { RootState } from '../store'

/**
 * Auth0のgetAccessTokenSilentlyを取得する
 * @returns getAccessTokenSilently
 */
export const getAccessTokenSilentlySelector = (state: RootState) =>
  state.auth.getAccessTokenSilently
